import React, { useCallback, useState, useEffect } from 'react';
import Quality from './quality';
import Timeline from './timeline';
import { useMedia } from '../../../hooks';
import { MediaEvents, MediaType } from '../../../common/media';
import CameraDirection from '../camera-direction';

type TPlayerProps = { target: string; type: MediaType; showAddons: boolean };

const Player = ({ target, type, showAddons }: TPlayerProps) => {
  const media = useMedia(target, type);
  const [state, setState] = useState({
    isPlaying: false,
    isMuted: false,
  });

  const handlePlay = useCallback(() => {
    if (media.isPaused()) {
      media.play();
    } else {
      media.pause();
    }
  }, [media]);

  const handleMute = useCallback(() => {
    if (media.isMuted()) {
      media.unmute();
    } else {
      media.mute();
    }
  }, [media]);

  useEffect(() => {
    if (!media) return;

    const handlePlay = () => {
      setState(st => ({
        ...st,
        isPlaying: !media.isPaused(),
      }));
    };

    const handleMute = () => {
      setState(st => ({
        ...st,
        isMuted: media.isMuted(),
      }));
    };

    media.on(MediaEvents.Play, handlePlay);
    media.on(MediaEvents.Pause, handlePlay);
    media.on(MediaEvents.Change_Mute, handleMute);

    return () => {
      media.off(MediaEvents.Play, handlePlay);
      media.off(MediaEvents.Pause, handlePlay);
      media.off(MediaEvents.Change_Mute, handleMute);
    };
  }, [media]);

  return (
    <>
      {showAddons ? <CameraDirection /> : null}

      <div className="player-footer">
        <div className={`player-footer-play ${state.isPlaying ? 'pause' : 'play'}`} onClick={handlePlay}></div>

        <div className="player-footer-volume" onClick={handleMute}>
          <div className="player-footer-volume-status ">
            <div className="player-footer-volume-icon"></div>
            <div className={`player-footer-volume-level ${state.isMuted ? 'invisible' : ''}`}></div>
          </div>
        </div>

        <Timeline target={target} />
        <Quality target={target} />
      </div>
    </>
  );
};

export default Player;
